import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  button: {
    background: '#FFFFFF',
    border: ({ variant }) =>
      `1px solid ${
        variant === 'success'
          ? theme.palette.variant.success
          : theme.palette.variant.error
      }`,
    borderRadius: '8px',
    fontSize: theme.size.base,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    cursor: 'pointer',
    height: 32,
    width: '100%',
    margin: '9px 8px 0px 0px',

    '& svg': {
      marginRight: 6
    },

    '&:last-child': {
      marginRight: '0'
    }
  },

  icon: {},

  spinner: {
    width: '12px !important',
    height: '12px !important',
    color: '#b7b7b7'
  }
}))

export default useStyles
